import React from 'react';
import classes from './Achievements.module.css';
import { AchievementsData } from '../../Assets/Data/AchievementsData';

const Achievements = () => {
  return (
    <>
      <div className={classes.achievements}>
        {AchievementsData.map((a, i) => {
          return (
            <div
              key={i}
              style={{ backgroundColor: a.color }}
              className={classes.achievement}
            >
              <div className={classes.image_container}>
                <img
                  className={classes.image}
                  src={a.imageSrc}
                  alt={`achi${i}`}
                />
              </div>
              <p className={classes.title}>{a.title}</p>
            </div>
          );
        })}
      </div>
      {/* <div className={classes.achievements}>
        {AchievementsData.map((a, i) => {
          return (
            <>
              <div className={classes.achievement}>
              <div className={classes.image_container}>
                <img
                  className={classes.image}
                  src={a.imageSrc}
                  alt={`achi${i}`}
                />
              </div>
              <p
                style={{ marginRight: "60%", marginBottom: "40px" }}
                className={classes.title}
              >
                {a.title}
              </p>
              </div>
            </>
          );
        })}
      </div> */}
    </>
  );
};

export default Achievements;
